import React from "react";
const Component0 = React.lazy(() => import("/src/widgets/linkedin/Carousel.jsx"));
const Component1 = React.lazy(() => import("/src/widgets/linkedin/Carousel.jsx"));
const Component2 = React.lazy(() => import("/src/widgets/linkedin/Grid.jsx"));
const Component3 = React.lazy(() => import("/src/widgets/linkedin/Grid.jsx"));
const Component4 = React.lazy(() => import("/src/widgets/linkedin/HeroWidget.jsx"));
const Component5 = React.lazy(() => import("/src/widgets/linkedin/HeroWidget.jsx"));
const Component6 = React.lazy(() => import("/src/widgets/linkedin/Slider.jsx"));
const Component7 = React.lazy(() => import("/src/widgets/linkedin/Slider.jsx"));
const Component8 = React.lazy(() => import("/src/widgets/linkedin/_connect.jsx"));
const Component9 = React.lazy(() => import("/src/widgets/linkedin/_connect.jsx"));
const Component10 = React.lazy(() => import("/src/widgets/linkedin/_layout.jsx"));
const Component11 = React.lazy(() => import("/src/widgets/linkedin/_layout.jsx"));
const Component12 = React.lazy(() => import("/src/widgets/linkedin/_settings.jsx"));
const Component13 = React.lazy(() => import("/src/widgets/linkedin/_settings.jsx"));
const Component14 = React.lazy(() => import("/src/widgets/linkedin/getnewsfeed.jsx"));
const Component15 = React.lazy(() => import("/src/widgets/linkedin/getnewsfeed.jsx"));
const Component16 = React.lazy(() => import("/src/widgets/linkedin/linkedin.jsx"));
const Component17 = React.lazy(() => import("/src/widgets/linkedin/linkedin.jsx"));
const Component18 = React.lazy(() => import("/src/widgets/outlook/MyFlaggedMails.jsx"));
const Component19 = React.lazy(() => import("/src/widgets/outlook/MyFlaggedMails.jsx"));
const Component20 = React.lazy(() => import("/src/widgets/outlook/MyInboxQuery.jsx"));
const Component21 = React.lazy(() => import("/src/widgets/outlook/MyInboxQuery.jsx"));
const Component22 = React.lazy(() => import("/src/widgets/outlook/SharedEvents.jsx"));
const Component23 = React.lazy(() => import("/src/widgets/outlook/SharedEvents.jsx"));
const Component24 = React.lazy(() => import("/src/widgets/outlook/SharedInboxQuery.jsx"));
const Component25 = React.lazy(() => import("/src/widgets/outlook/SharedInboxQuery.jsx"));
const Component26 = React.lazy(() => import("/src/widgets/outlook/_connect.jsx"));
const Component27 = React.lazy(() => import("/src/widgets/outlook/_connect.jsx"));
const Component28 = React.lazy(() => import("/src/widgets/outlook/_endpoint.jsx"));
const Component29 = React.lazy(() => import("/src/widgets/outlook/_endpoint.jsx"));
const Component30 = React.lazy(() => import("/src/widgets/outlook/_layout.jsx"));
const Component31 = React.lazy(() => import("/src/widgets/outlook/_layout.jsx"));
const Component32 = React.lazy(() => import("/src/widgets/outlook/_sharedevents.jsx"));
const Component33 = React.lazy(() => import("/src/widgets/outlook/_sharedevents.jsx"));
const Component34 = React.lazy(() => import("/src/widgets/outlook/_sharedmailbox.jsx"));
const Component35 = React.lazy(() => import("/src/widgets/outlook/_sharedmailbox.jsx"));
const Component36 = React.lazy(() => import("/src/widgets/outlook/calendar.jsx"));
const Component37 = React.lazy(() => import("/src/widgets/outlook/calendar.jsx"));
const Component38 = React.lazy(() => import("/src/widgets/outlook/events.jsx"));
const Component39 = React.lazy(() => import("/src/widgets/outlook/events.jsx"));
const Component40 = React.lazy(() => import("/src/widgets/outlook/focused-inbox.jsx"));
const Component41 = React.lazy(() => import("/src/widgets/outlook/focused-inbox.jsx"));
const Component42 = React.lazy(() => import("/src/widgets/outlook/outlook-calendar-wip.jsx"));
const Component43 = React.lazy(() => import("/src/widgets/outlook/outlook-calendar-wip.jsx"));
const Component44 = React.lazy(() => import("/src/widgets/outlook/to-do-tasks.jsx"));
const Component45 = React.lazy(() => import("/src/widgets/outlook/to-do-tasks.jsx"));
const Component46 = React.lazy(() => import("/src/widgets/rss/BottomBar.jsx"));
const Component47 = React.lazy(() => import("/src/widgets/rss/BottomBar.jsx"));
const Component48 = React.lazy(() => import("/src/widgets/rss/CriticalAnnouncement.jsx"));
const Component49 = React.lazy(() => import("/src/widgets/rss/CriticalAnnouncement.jsx"));
const Component50 = React.lazy(() => import("/src/widgets/rss/HeroWidget.jsx"));
const Component51 = React.lazy(() => import("/src/widgets/rss/HeroWidget.jsx"));
const Component52 = React.lazy(() => import("/src/widgets/rss/ImportantNews.jsx"));
const Component53 = React.lazy(() => import("/src/widgets/rss/ImportantNews.jsx"));
const Component54 = React.lazy(() => import("/src/widgets/rss/NewsCarousel.jsx"));
const Component55 = React.lazy(() => import("/src/widgets/rss/NewsCarousel.jsx"));
const Component56 = React.lazy(() => import("/src/widgets/rss/NewsCarouselLargeImage.jsx"));
const Component57 = React.lazy(() => import("/src/widgets/rss/NewsCarouselLargeImage.jsx"));
const Component58 = React.lazy(() => import("/src/widgets/rss/NewsGallery.jsx"));
const Component59 = React.lazy(() => import("/src/widgets/rss/NewsGallery.jsx"));
const Component60 = React.lazy(() => import("/src/widgets/rss/NewsReader.jsx"));
const Component61 = React.lazy(() => import("/src/widgets/rss/NewsReader.jsx"));
const Component62 = React.lazy(() => import("/src/widgets/rss/Ticker.jsx"));
const Component63 = React.lazy(() => import("/src/widgets/rss/Ticker.jsx"));
const Component64 = React.lazy(() => import("/src/widgets/rss/TopBar.jsx"));
const Component65 = React.lazy(() => import("/src/widgets/rss/TopBar.jsx"));
const Component66 = React.lazy(() => import("/src/widgets/rss/_connect.jsx"));
const Component67 = React.lazy(() => import("/src/widgets/rss/_connect.jsx"));
const Component68 = React.lazy(() => import("/src/widgets/rss/_layout.jsx"));
const Component69 = React.lazy(() => import("/src/widgets/rss/_layout.jsx"));
const Component70 = React.lazy(() => import("/src/widgets/rss/_settings.jsx"));
const Component71 = React.lazy(() => import("/src/widgets/rss/_settings.jsx"));
const Component72 = React.lazy(() => import("/src/widgets/rss/default.jsx"));
const Component73 = React.lazy(() => import("/src/widgets/rss/default.jsx"));
const Component74 = React.lazy(() => import("/src/pages/CardCreator.jsx"));
const Component75 = React.lazy(() => import("/src/pages/CardCreator.jsx"));
const Component76 = React.lazy(() => import("/src/pages/CardCreator.jsx"));
const Component77 = React.lazy(() => import("/src/pages/CardCreator.jsx"));
const Component78 = React.lazy(() => import("/src/pages/CardCreator102.jsx"));
const Component79 = React.lazy(() => import("/src/pages/CardCreator102.jsx"));
const Component80 = React.lazy(() => import("/src/pages/CardCreator102.jsx"));
const Component81 = React.lazy(() => import("/src/pages/CardCreator102.jsx"));
const Component82 = React.lazy(() => import("/src/pages/CardForm.jsx"));
const Component83 = React.lazy(() => import("/src/pages/CardForm.jsx"));
const Component84 = React.lazy(() => import("/src/pages/CardForm.jsx"));
const Component85 = React.lazy(() => import("/src/pages/CardForm.jsx"));
const Component86 = React.lazy(() => import("/src/pages/CardGrid.jsx"));
const Component87 = React.lazy(() => import("/src/pages/CardGrid.jsx"));
const Component88 = React.lazy(() => import("/src/pages/CardGrid.jsx"));
const Component89 = React.lazy(() => import("/src/pages/CardGrid.jsx"));
const Component90 = React.lazy(() => import("/src/pages/JsonDateConverter.jsx"));
const Component91 = React.lazy(() => import("/src/pages/JsonDateConverter.jsx"));
const Component92 = React.lazy(() => import("/src/pages/JsonDateConverter.jsx"));
const Component93 = React.lazy(() => import("/src/pages/JsonDateConverter.jsx"));
const Component94 = React.lazy(() => import("/src/pages/RSSForm.jsx"));
const Component95 = React.lazy(() => import("/src/pages/RSSForm.jsx"));
const Component96 = React.lazy(() => import("/src/pages/RSSForm.jsx"));
const Component97 = React.lazy(() => import("/src/pages/RSSForm.jsx"));
const Component98 = React.lazy(() => import("/src/pages/RecentContactList.jsx"));
const Component99 = React.lazy(() => import("/src/pages/RecentContactList.jsx"));
const Component100 = React.lazy(() => import("/src/pages/RecentContactList.jsx"));
const Component101 = React.lazy(() => import("/src/pages/RecentContactList.jsx"));
const Component102 = React.lazy(() => import("/src/pages/RestForm.jsx"));
const Component103 = React.lazy(() => import("/src/pages/RestForm.jsx"));
const Component104 = React.lazy(() => import("/src/pages/RestForm.jsx"));
const Component105 = React.lazy(() => import("/src/pages/RestForm.jsx"));
const Component106 = React.lazy(() => import("/src/pages/RestForm2.jsx"));
const Component107 = React.lazy(() => import("/src/pages/RestForm2.jsx"));
const Component108 = React.lazy(() => import("/src/pages/RestForm2.jsx"));
const Component109 = React.lazy(() => import("/src/pages/RestForm2.jsx"));
const Component110 = React.lazy(() => import("/src/pages/RestForm3.jsx"));
const Component111 = React.lazy(() => import("/src/pages/RestForm3.jsx"));
const Component112 = React.lazy(() => import("/src/pages/RestForm3.jsx"));
const Component113 = React.lazy(() => import("/src/pages/RestForm3.jsx"));
const Component114 = React.lazy(() => import("/src/pages/UserInfoCard.jsx"));
const Component115 = React.lazy(() => import("/src/pages/UserInfoCard.jsx"));
const Component116 = React.lazy(() => import("/src/pages/UserInfoCard.jsx"));
const Component117 = React.lazy(() => import("/src/pages/UserInfoCard.jsx"));
const Component118 = React.lazy(() => import("/src/pages/WidgetConfig.jsx"));
const Component119 = React.lazy(() => import("/src/pages/WidgetConfig.jsx"));
const Component120 = React.lazy(() => import("/src/pages/WidgetConfig.jsx"));
const Component121 = React.lazy(() => import("/src/pages/WidgetConfig.jsx"));
const Component122 = React.lazy(() => import("/src/pages/apiSample.jsx"));
const Component123 = React.lazy(() => import("/src/pages/apiSample.jsx"));
const Component124 = React.lazy(() => import("/src/pages/apiSample.jsx"));
const Component125 = React.lazy(() => import("/src/pages/apiSample.jsx"));
const Component126 = React.lazy(() => import("/src/pages/arti.jsx"));
const Component127 = React.lazy(() => import("/src/pages/arti.jsx"));
const Component128 = React.lazy(() => import("/src/pages/arti.jsx"));
const Component129 = React.lazy(() => import("/src/pages/arti.jsx"));
const Component130 = React.lazy(() => import("/src/pages/artifact.jsx"));
const Component131 = React.lazy(() => import("/src/pages/artifact.jsx"));
const Component132 = React.lazy(() => import("/src/pages/artifact.jsx"));
const Component133 = React.lazy(() => import("/src/pages/artifact.jsx"));
const Component134 = React.lazy(() => import("/src/pages/asana-getTasksForProjectBoard.jsx"));
const Component135 = React.lazy(() => import("/src/pages/asana-getTasksForProjectBoard.jsx"));
const Component136 = React.lazy(() => import("/src/pages/asana-getTasksForProjectBoard.jsx"));
const Component137 = React.lazy(() => import("/src/pages/asana-getTasksForProjectBoard.jsx"));
const Component138 = React.lazy(() => import("/src/pages/auth-callback.jsx"));
const Component139 = React.lazy(() => import("/src/pages/auth-callback.jsx"));
const Component140 = React.lazy(() => import("/src/pages/auth-callback.jsx"));
const Component141 = React.lazy(() => import("/src/pages/auth-callback.jsx"));
const Component142 = React.lazy(() => import("/src/pages/auth-complete.jsx"));
const Component143 = React.lazy(() => import("/src/pages/auth-complete.jsx"));
const Component144 = React.lazy(() => import("/src/pages/auth-complete.jsx"));
const Component145 = React.lazy(() => import("/src/pages/auth-complete.jsx"));
const Component146 = React.lazy(() => import("/src/pages/calendar.tsx"));
const Component147 = React.lazy(() => import("/src/pages/calendar.tsx"));
const Component148 = React.lazy(() => import("/src/pages/calendar.tsx"));
const Component149 = React.lazy(() => import("/src/pages/calendar.tsx"));
const Component150 = React.lazy(() => import("/src/pages/card-embed.jsx"));
const Component151 = React.lazy(() => import("/src/pages/card-embed.jsx"));
const Component152 = React.lazy(() => import("/src/pages/card-embed.jsx"));
const Component153 = React.lazy(() => import("/src/pages/card-embed.jsx"));
const Component154 = React.lazy(() => import("/src/pages/chatsimple.jsx"));
const Component155 = React.lazy(() => import("/src/pages/chatsimple.jsx"));
const Component156 = React.lazy(() => import("/src/pages/chatsimple.jsx"));
const Component157 = React.lazy(() => import("/src/pages/chatsimple.jsx"));
const Component158 = React.lazy(() => import("/src/pages/clickup-GetFolder.jsx"));
const Component159 = React.lazy(() => import("/src/pages/clickup-GetFolder.jsx"));
const Component160 = React.lazy(() => import("/src/pages/clickup-GetFolder.jsx"));
const Component161 = React.lazy(() => import("/src/pages/clickup-GetFolder.jsx"));
const Component162 = React.lazy(() => import("/src/pages/clickup-Tasks.jsx"));
const Component163 = React.lazy(() => import("/src/pages/clickup-Tasks.jsx"));
const Component164 = React.lazy(() => import("/src/pages/clickup-Tasks.jsx"));
const Component165 = React.lazy(() => import("/src/pages/clickup-Tasks.jsx"));
const Component166 = React.lazy(() => import("/src/pages/configpage-proto1.jsx"));
const Component167 = React.lazy(() => import("/src/pages/configpage-proto1.jsx"));
const Component168 = React.lazy(() => import("/src/pages/configpage-proto1.jsx"));
const Component169 = React.lazy(() => import("/src/pages/configpage-proto1.jsx"));
const Component170 = React.lazy(() => import("/src/pages/confluence-getPageById.jsx"));
const Component171 = React.lazy(() => import("/src/pages/confluence-getPageById.jsx"));
const Component172 = React.lazy(() => import("/src/pages/confluence-getPageById.jsx"));
const Component173 = React.lazy(() => import("/src/pages/confluence-getPageById.jsx"));
const Component174 = React.lazy(() => import("/src/pages/confluence-getPages.jsx"));
const Component175 = React.lazy(() => import("/src/pages/confluence-getPages.jsx"));
const Component176 = React.lazy(() => import("/src/pages/confluence-getPages.jsx"));
const Component177 = React.lazy(() => import("/src/pages/confluence-getPages.jsx"));
const Component178 = React.lazy(() => import("/src/pages/counter.jsx"));
const Component179 = React.lazy(() => import("/src/pages/counter.jsx"));
const Component180 = React.lazy(() => import("/src/pages/counter.jsx"));
const Component181 = React.lazy(() => import("/src/pages/counter.jsx"));
const Component182 = React.lazy(() => import("/src/pages/dashboard.jsx"));
const Component183 = React.lazy(() => import("/src/pages/dashboard.jsx"));
const Component184 = React.lazy(() => import("/src/pages/dashboard.jsx"));
const Component185 = React.lazy(() => import("/src/pages/dashboard.jsx"));
const Component186 = React.lazy(() => import("/src/pages/datagrid.jsx"));
const Component187 = React.lazy(() => import("/src/pages/datagrid.jsx"));
const Component188 = React.lazy(() => import("/src/pages/datagrid.jsx"));
const Component189 = React.lazy(() => import("/src/pages/datagrid.jsx"));
const Component190 = React.lazy(() => import("/src/pages/default.jsx"));
const Component191 = React.lazy(() => import("/src/pages/default.jsx"));
const Component192 = React.lazy(() => import("/src/pages/default.jsx"));
const Component193 = React.lazy(() => import("/src/pages/default.jsx"));
const Component194 = React.lazy(() => import("/src/pages/dropbox-SearchAlert.jsx"));
const Component195 = React.lazy(() => import("/src/pages/dropbox-SearchAlert.jsx"));
const Component196 = React.lazy(() => import("/src/pages/dropbox-SearchAlert.jsx"));
const Component197 = React.lazy(() => import("/src/pages/dropbox-SearchAlert.jsx"));
const Component198 = React.lazy(() => import("/src/pages/edit.jsx"));
const Component199 = React.lazy(() => import("/src/pages/edit.jsx"));
const Component200 = React.lazy(() => import("/src/pages/edit.jsx"));
const Component201 = React.lazy(() => import("/src/pages/edit.jsx"));
const Component202 = React.lazy(() => import("/src/pages/formtest.jsx"));
const Component203 = React.lazy(() => import("/src/pages/formtest.jsx"));
const Component204 = React.lazy(() => import("/src/pages/formtest.jsx"));
const Component205 = React.lazy(() => import("/src/pages/formtest.jsx"));
const Component206 = React.lazy(() => import("/src/pages/formtest1.jsx"));
const Component207 = React.lazy(() => import("/src/pages/formtest1.jsx"));
const Component208 = React.lazy(() => import("/src/pages/formtest1.jsx"));
const Component209 = React.lazy(() => import("/src/pages/formtest1.jsx"));
const Component210 = React.lazy(() => import("/src/pages/gallery.jsx"));
const Component211 = React.lazy(() => import("/src/pages/gallery.jsx"));
const Component212 = React.lazy(() => import("/src/pages/gallery.jsx"));
const Component213 = React.lazy(() => import("/src/pages/gallery.jsx"));
const Component214 = React.lazy(() => import("/src/pages/genie-error1.jsx"));
const Component215 = React.lazy(() => import("/src/pages/genie-error1.jsx"));
const Component216 = React.lazy(() => import("/src/pages/genie-error1.jsx"));
const Component217 = React.lazy(() => import("/src/pages/genie-error1.jsx"));
const Component218 = React.lazy(() => import("/src/pages/genie.jsx"));
const Component219 = React.lazy(() => import("/src/pages/genie.jsx"));
const Component220 = React.lazy(() => import("/src/pages/genie.jsx"));
const Component221 = React.lazy(() => import("/src/pages/genie.jsx"));
const Component222 = React.lazy(() => import("/src/pages/hello.jsx"));
const Component223 = React.lazy(() => import("/src/pages/hello.jsx"));
const Component224 = React.lazy(() => import("/src/pages/hello.jsx"));
const Component225 = React.lazy(() => import("/src/pages/hello.jsx"));
const Component226 = React.lazy(() => import("/src/pages/hello0.jsx"));
const Component227 = React.lazy(() => import("/src/pages/hello0.jsx"));
const Component228 = React.lazy(() => import("/src/pages/hello0.jsx"));
const Component229 = React.lazy(() => import("/src/pages/hello0.jsx"));
const Component230 = React.lazy(() => import("/src/pages/hello1.jsx"));
const Component231 = React.lazy(() => import("/src/pages/hello1.jsx"));
const Component232 = React.lazy(() => import("/src/pages/hello1.jsx"));
const Component233 = React.lazy(() => import("/src/pages/hello1.jsx"));
const Component234 = React.lazy(() => import("/src/pages/hsl-color-converter.jsx"));
const Component235 = React.lazy(() => import("/src/pages/hsl-color-converter.jsx"));
const Component236 = React.lazy(() => import("/src/pages/hsl-color-converter.jsx"));
const Component237 = React.lazy(() => import("/src/pages/hsl-color-converter.jsx"));
const Component238 = React.lazy(() => import("/src/pages/hubspot-GetRecentContactList.jsx"));
const Component239 = React.lazy(() => import("/src/pages/hubspot-GetRecentContactList.jsx"));
const Component240 = React.lazy(() => import("/src/pages/hubspot-GetRecentContactList.jsx"));
const Component241 = React.lazy(() => import("/src/pages/hubspot-GetRecentContactList.jsx"));
const Component242 = React.lazy(() => import("/src/pages/jira-open-issues.jsx"));
const Component243 = React.lazy(() => import("/src/pages/jira-open-issues.jsx"));
const Component244 = React.lazy(() => import("/src/pages/jira-open-issues.jsx"));
const Component245 = React.lazy(() => import("/src/pages/jira-open-issues.jsx"));
const Component246 = React.lazy(() => import("/src/pages/linkedin-Carousel.jsx"));
const Component247 = React.lazy(() => import("/src/pages/linkedin-Carousel.jsx"));
const Component248 = React.lazy(() => import("/src/pages/linkedin-Carousel.jsx"));
const Component249 = React.lazy(() => import("/src/pages/linkedin-Carousel.jsx"));
const Component250 = React.lazy(() => import("/src/pages/linkedin-GetNewsFeed.jsx"));
const Component251 = React.lazy(() => import("/src/pages/linkedin-GetNewsFeed.jsx"));
const Component252 = React.lazy(() => import("/src/pages/linkedin-GetNewsFeed.jsx"));
const Component253 = React.lazy(() => import("/src/pages/linkedin-GetNewsFeed.jsx"));
const Component254 = React.lazy(() => import("/src/pages/linkedin-Grid.jsx"));
const Component255 = React.lazy(() => import("/src/pages/linkedin-Grid.jsx"));
const Component256 = React.lazy(() => import("/src/pages/linkedin-Grid.jsx"));
const Component257 = React.lazy(() => import("/src/pages/linkedin-Grid.jsx"));
const Component258 = React.lazy(() => import("/src/pages/linkedin-HeroWidget.jsx"));
const Component259 = React.lazy(() => import("/src/pages/linkedin-HeroWidget.jsx"));
const Component260 = React.lazy(() => import("/src/pages/linkedin-HeroWidget.jsx"));
const Component261 = React.lazy(() => import("/src/pages/linkedin-HeroWidget.jsx"));
const Component262 = React.lazy(() => import("/src/pages/linkedin-Slider.jsx"));
const Component263 = React.lazy(() => import("/src/pages/linkedin-Slider.jsx"));
const Component264 = React.lazy(() => import("/src/pages/linkedin-Slider.jsx"));
const Component265 = React.lazy(() => import("/src/pages/linkedin-Slider.jsx"));
const Component266 = React.lazy(() => import("/src/pages/llm-web-part-edit-recommendation.jsx"));
const Component267 = React.lazy(() => import("/src/pages/llm-web-part-edit-recommendation.jsx"));
const Component268 = React.lazy(() => import("/src/pages/llm-web-part-edit-recommendation.jsx"));
const Component269 = React.lazy(() => import("/src/pages/llm-web-part-edit-recommendation.jsx"));
const Component270 = React.lazy(() => import("/src/pages/llm-web-part-empty-state.jsx"));
const Component271 = React.lazy(() => import("/src/pages/llm-web-part-empty-state.jsx"));
const Component272 = React.lazy(() => import("/src/pages/llm-web-part-empty-state.jsx"));
const Component273 = React.lazy(() => import("/src/pages/llm-web-part-empty-state.jsx"));
const Component274 = React.lazy(() => import("/src/pages/maker0.jsx"));
const Component275 = React.lazy(() => import("/src/pages/maker0.jsx"));
const Component276 = React.lazy(() => import("/src/pages/maker0.jsx"));
const Component277 = React.lazy(() => import("/src/pages/maker0.jsx"));
const Component278 = React.lazy(() => import("/src/pages/microsoft-lists-TravelRequests.jsx"));
const Component279 = React.lazy(() => import("/src/pages/microsoft-lists-TravelRequests.jsx"));
const Component280 = React.lazy(() => import("/src/pages/microsoft-lists-TravelRequests.jsx"));
const Component281 = React.lazy(() => import("/src/pages/microsoft-lists-TravelRequests.jsx"));
const Component282 = React.lazy(() => import("/src/pages/msshifts-UpcomingShifts.jsx"));
const Component283 = React.lazy(() => import("/src/pages/msshifts-UpcomingShifts.jsx"));
const Component284 = React.lazy(() => import("/src/pages/msshifts-UpcomingShifts.jsx"));
const Component285 = React.lazy(() => import("/src/pages/msshifts-UpcomingShifts.jsx"));
const Component286 = React.lazy(() => import("/src/pages/news0.jsx"));
const Component287 = React.lazy(() => import("/src/pages/news0.jsx"));
const Component288 = React.lazy(() => import("/src/pages/news0.jsx"));
const Component289 = React.lazy(() => import("/src/pages/news0.jsx"));
const Component290 = React.lazy(() => import("/src/pages/news1.jsx"));
const Component291 = React.lazy(() => import("/src/pages/news1.jsx"));
const Component292 = React.lazy(() => import("/src/pages/news1.jsx"));
const Component293 = React.lazy(() => import("/src/pages/news1.jsx"));
const Component294 = React.lazy(() => import("/src/pages/outlook-MyInboxQuery.jsx"));
const Component295 = React.lazy(() => import("/src/pages/outlook-MyInboxQuery.jsx"));
const Component296 = React.lazy(() => import("/src/pages/outlook-MyInboxQuery.jsx"));
const Component297 = React.lazy(() => import("/src/pages/outlook-MyInboxQuery.jsx"));
const Component298 = React.lazy(() => import("/src/pages/outlook-SharedInboxQuery.jsx"));
const Component299 = React.lazy(() => import("/src/pages/outlook-SharedInboxQuery.jsx"));
const Component300 = React.lazy(() => import("/src/pages/outlook-SharedInboxQuery.jsx"));
const Component301 = React.lazy(() => import("/src/pages/outlook-SharedInboxQuery.jsx"));
const Component302 = React.lazy(() => import("/src/pages/outlook-calendar-wip.jsx"));
const Component303 = React.lazy(() => import("/src/pages/outlook-calendar-wip.jsx"));
const Component304 = React.lazy(() => import("/src/pages/outlook-calendar-wip.jsx"));
const Component305 = React.lazy(() => import("/src/pages/outlook-calendar-wip.jsx"));
const Component306 = React.lazy(() => import("/src/pages/outlook-calendar.jsx"));
const Component307 = React.lazy(() => import("/src/pages/outlook-calendar.jsx"));
const Component308 = React.lazy(() => import("/src/pages/outlook-calendar.jsx"));
const Component309 = React.lazy(() => import("/src/pages/outlook-calendar.jsx"));
const Component310 = React.lazy(() => import("/src/pages/outlook-focused-inbox.jsx"));
const Component311 = React.lazy(() => import("/src/pages/outlook-focused-inbox.jsx"));
const Component312 = React.lazy(() => import("/src/pages/outlook-focused-inbox.jsx"));
const Component313 = React.lazy(() => import("/src/pages/outlook-focused-inbox.jsx"));
const Component314 = React.lazy(() => import("/src/pages/outlook-upcoming-events.jsx"));
const Component315 = React.lazy(() => import("/src/pages/outlook-upcoming-events.jsx"));
const Component316 = React.lazy(() => import("/src/pages/outlook-upcoming-events.jsx"));
const Component317 = React.lazy(() => import("/src/pages/outlook-upcoming-events.jsx"));
const Component318 = React.lazy(() => import("/src/pages/pgquery.jsx"));
const Component319 = React.lazy(() => import("/src/pages/pgquery.jsx"));
const Component320 = React.lazy(() => import("/src/pages/pgquery.jsx"));
const Component321 = React.lazy(() => import("/src/pages/pgquery.jsx"));
const Component322 = React.lazy(() => import("/src/pages/podcast-list.jsx"));
const Component323 = React.lazy(() => import("/src/pages/podcast-list.jsx"));
const Component324 = React.lazy(() => import("/src/pages/podcast-list.jsx"));
const Component325 = React.lazy(() => import("/src/pages/podcast-list.jsx"));
const Component326 = React.lazy(() => import("/src/pages/podcasts-default.jsx"));
const Component327 = React.lazy(() => import("/src/pages/podcasts-default.jsx"));
const Component328 = React.lazy(() => import("/src/pages/podcasts-default.jsx"));
const Component329 = React.lazy(() => import("/src/pages/podcasts-default.jsx"));
const Component330 = React.lazy(() => import("/src/pages/rhf-form1.jsx"));
const Component331 = React.lazy(() => import("/src/pages/rhf-form1.jsx"));
const Component332 = React.lazy(() => import("/src/pages/rhf-form1.jsx"));
const Component333 = React.lazy(() => import("/src/pages/rhf-form1.jsx"));
const Component334 = React.lazy(() => import("/src/pages/rss-BottomBar.jsx"));
const Component335 = React.lazy(() => import("/src/pages/rss-BottomBar.jsx"));
const Component336 = React.lazy(() => import("/src/pages/rss-BottomBar.jsx"));
const Component337 = React.lazy(() => import("/src/pages/rss-BottomBar.jsx"));
const Component338 = React.lazy(() => import("/src/pages/rss-CriticalAnnouncement.jsx"));
const Component339 = React.lazy(() => import("/src/pages/rss-CriticalAnnouncement.jsx"));
const Component340 = React.lazy(() => import("/src/pages/rss-CriticalAnnouncement.jsx"));
const Component341 = React.lazy(() => import("/src/pages/rss-CriticalAnnouncement.jsx"));
const Component342 = React.lazy(() => import("/src/pages/rss-HeroWidget.jsx"));
const Component343 = React.lazy(() => import("/src/pages/rss-HeroWidget.jsx"));
const Component344 = React.lazy(() => import("/src/pages/rss-HeroWidget.jsx"));
const Component345 = React.lazy(() => import("/src/pages/rss-HeroWidget.jsx"));
const Component346 = React.lazy(() => import("/src/pages/rss-ImportantNews.jsx"));
const Component347 = React.lazy(() => import("/src/pages/rss-ImportantNews.jsx"));
const Component348 = React.lazy(() => import("/src/pages/rss-ImportantNews.jsx"));
const Component349 = React.lazy(() => import("/src/pages/rss-ImportantNews.jsx"));
const Component350 = React.lazy(() => import("/src/pages/rss-NewsCarousel.jsx"));
const Component351 = React.lazy(() => import("/src/pages/rss-NewsCarousel.jsx"));
const Component352 = React.lazy(() => import("/src/pages/rss-NewsCarousel.jsx"));
const Component353 = React.lazy(() => import("/src/pages/rss-NewsCarousel.jsx"));
const Component354 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage (1).jsx"));
const Component355 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage (1).jsx"));
const Component356 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage (1).jsx"));
const Component357 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage (1).jsx"));
const Component358 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage.jsx"));
const Component359 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage.jsx"));
const Component360 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage.jsx"));
const Component361 = React.lazy(() => import("/src/pages/rss-NewsCarouselLargeImage.jsx"));
const Component362 = React.lazy(() => import("/src/pages/rss-NewsGallery.jsx"));
const Component363 = React.lazy(() => import("/src/pages/rss-NewsGallery.jsx"));
const Component364 = React.lazy(() => import("/src/pages/rss-NewsGallery.jsx"));
const Component365 = React.lazy(() => import("/src/pages/rss-NewsGallery.jsx"));
const Component366 = React.lazy(() => import("/src/pages/rss-NewsReader.jsx"));
const Component367 = React.lazy(() => import("/src/pages/rss-NewsReader.jsx"));
const Component368 = React.lazy(() => import("/src/pages/rss-NewsReader.jsx"));
const Component369 = React.lazy(() => import("/src/pages/rss-NewsReader.jsx"));
const Component370 = React.lazy(() => import("/src/pages/rss-Ticker.jsx"));
const Component371 = React.lazy(() => import("/src/pages/rss-Ticker.jsx"));
const Component372 = React.lazy(() => import("/src/pages/rss-Ticker.jsx"));
const Component373 = React.lazy(() => import("/src/pages/rss-Ticker.jsx"));
const Component374 = React.lazy(() => import("/src/pages/rss-TopBar.jsx"));
const Component375 = React.lazy(() => import("/src/pages/rss-TopBar.jsx"));
const Component376 = React.lazy(() => import("/src/pages/rss-TopBar.jsx"));
const Component377 = React.lazy(() => import("/src/pages/rss-TopBar.jsx"));
const Component378 = React.lazy(() => import("/src/pages/rss-conconf.jsx"));
const Component379 = React.lazy(() => import("/src/pages/rss-conconf.jsx"));
const Component380 = React.lazy(() => import("/src/pages/rss-conconf.jsx"));
const Component381 = React.lazy(() => import("/src/pages/rss-conconf.jsx"));
const Component382 = React.lazy(() => import("/src/pages/rss-default.jsx"));
const Component383 = React.lazy(() => import("/src/pages/rss-default.jsx"));
const Component384 = React.lazy(() => import("/src/pages/rss-default.jsx"));
const Component385 = React.lazy(() => import("/src/pages/rss-default.jsx"));
const Component386 = React.lazy(() => import("/src/pages/settings.jsx"));
const Component387 = React.lazy(() => import("/src/pages/settings.jsx"));
const Component388 = React.lazy(() => import("/src/pages/settings.jsx"));
const Component389 = React.lazy(() => import("/src/pages/settings.jsx"));
const Component390 = React.lazy(() => import("/src/pages/slack-ConversationHistory-compact.jsx"));
const Component391 = React.lazy(() => import("/src/pages/slack-ConversationHistory-compact.jsx"));
const Component392 = React.lazy(() => import("/src/pages/slack-ConversationHistory-compact.jsx"));
const Component393 = React.lazy(() => import("/src/pages/slack-ConversationHistory-compact.jsx"));
const Component394 = React.lazy(() => import("/src/pages/slack-ConversationHistory-v0.jsx"));
const Component395 = React.lazy(() => import("/src/pages/slack-ConversationHistory-v0.jsx"));
const Component396 = React.lazy(() => import("/src/pages/slack-ConversationHistory-v0.jsx"));
const Component397 = React.lazy(() => import("/src/pages/slack-ConversationHistory-v0.jsx"));
const Component398 = React.lazy(() => import("/src/pages/slack-ConversationHistory.jsx"));
const Component399 = React.lazy(() => import("/src/pages/slack-ConversationHistory.jsx"));
const Component400 = React.lazy(() => import("/src/pages/slack-ConversationHistory.jsx"));
const Component401 = React.lazy(() => import("/src/pages/slack-ConversationHistory.jsx"));
const Component402 = React.lazy(() => import("/src/pages/stock-quote-Widget.jsx"));
const Component403 = React.lazy(() => import("/src/pages/stock-quote-Widget.jsx"));
const Component404 = React.lazy(() => import("/src/pages/stock-quote-Widget.jsx"));
const Component405 = React.lazy(() => import("/src/pages/stock-quote-Widget.jsx"));
const Component406 = React.lazy(() => import("/src/pages/typography.jsx"));
const Component407 = React.lazy(() => import("/src/pages/typography.jsx"));
const Component408 = React.lazy(() => import("/src/pages/typography.jsx"));
const Component409 = React.lazy(() => import("/src/pages/typography.jsx"));
const Component410 = React.lazy(() => import("/src/pages/xero-employee-leave-uk-nz.jsx"));
const Component411 = React.lazy(() => import("/src/pages/xero-employee-leave-uk-nz.jsx"));
const Component412 = React.lazy(() => import("/src/pages/xero-employee-leave-uk-nz.jsx"));
const Component413 = React.lazy(() => import("/src/pages/xero-employee-leave-uk-nz.jsx"));
const Component414 = React.lazy(() => import("/src/pages/xkcd.jsx"));
const Component415 = React.lazy(() => import("/src/pages/xkcd.jsx"));
const Component416 = React.lazy(() => import("/src/pages/xkcd.jsx"));
const Component417 = React.lazy(() => import("/src/pages/xkcd.jsx"));

const routes = [
  {
    "path": "webpart/widgets/linkedin/Carousel",
    "element": React.createElement(Component0),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/Carousel",
    "element": React.createElement(Component1),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/Grid",
    "element": React.createElement(Component2),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/Grid",
    "element": React.createElement(Component3),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/HeroWidget",
    "element": React.createElement(Component4),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/HeroWidget",
    "element": React.createElement(Component5),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/Slider",
    "element": React.createElement(Component6),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/Slider",
    "element": React.createElement(Component7),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/_connect",
    "element": React.createElement(Component8),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/_connect",
    "element": React.createElement(Component9),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/_layout",
    "element": React.createElement(Component10),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/_layout",
    "element": React.createElement(Component11),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/_settings",
    "element": React.createElement(Component12),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/_settings",
    "element": React.createElement(Component13),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/getnewsfeed",
    "element": React.createElement(Component14),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/getnewsfeed",
    "element": React.createElement(Component15),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/linkedin/linkedin",
    "element": React.createElement(Component16),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/linkedin/linkedin",
    "element": React.createElement(Component17),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/MyFlaggedMails",
    "element": React.createElement(Component18),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/MyFlaggedMails",
    "element": React.createElement(Component19),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/MyInboxQuery",
    "element": React.createElement(Component20),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/MyInboxQuery",
    "element": React.createElement(Component21),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/SharedEvents",
    "element": React.createElement(Component22),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/SharedEvents",
    "element": React.createElement(Component23),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/SharedInboxQuery",
    "element": React.createElement(Component24),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/SharedInboxQuery",
    "element": React.createElement(Component25),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/_connect",
    "element": React.createElement(Component26),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/_connect",
    "element": React.createElement(Component27),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/_endpoint",
    "element": React.createElement(Component28),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/_endpoint",
    "element": React.createElement(Component29),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/_layout",
    "element": React.createElement(Component30),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/_layout",
    "element": React.createElement(Component31),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/_sharedevents",
    "element": React.createElement(Component32),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/_sharedevents",
    "element": React.createElement(Component33),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/_sharedmailbox",
    "element": React.createElement(Component34),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/_sharedmailbox",
    "element": React.createElement(Component35),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/calendar",
    "element": React.createElement(Component36),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/calendar",
    "element": React.createElement(Component37),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/events",
    "element": React.createElement(Component38),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/events",
    "element": React.createElement(Component39),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/focused-inbox",
    "element": React.createElement(Component40),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/focused-inbox",
    "element": React.createElement(Component41),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/outlook-calendar-wip",
    "element": React.createElement(Component42),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/outlook-calendar-wip",
    "element": React.createElement(Component43),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/outlook/to-do-tasks",
    "element": React.createElement(Component44),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/outlook/to-do-tasks",
    "element": React.createElement(Component45),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/BottomBar",
    "element": React.createElement(Component46),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/BottomBar",
    "element": React.createElement(Component47),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/CriticalAnnouncement",
    "element": React.createElement(Component48),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/CriticalAnnouncement",
    "element": React.createElement(Component49),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/HeroWidget",
    "element": React.createElement(Component50),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/HeroWidget",
    "element": React.createElement(Component51),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/ImportantNews",
    "element": React.createElement(Component52),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/ImportantNews",
    "element": React.createElement(Component53),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/NewsCarousel",
    "element": React.createElement(Component54),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/NewsCarousel",
    "element": React.createElement(Component55),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/NewsCarouselLargeImage",
    "element": React.createElement(Component56),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/NewsCarouselLargeImage",
    "element": React.createElement(Component57),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/NewsGallery",
    "element": React.createElement(Component58),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/NewsGallery",
    "element": React.createElement(Component59),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/NewsReader",
    "element": React.createElement(Component60),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/NewsReader",
    "element": React.createElement(Component61),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/Ticker",
    "element": React.createElement(Component62),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/Ticker",
    "element": React.createElement(Component63),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/TopBar",
    "element": React.createElement(Component64),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/TopBar",
    "element": React.createElement(Component65),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/_connect",
    "element": React.createElement(Component66),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/_connect",
    "element": React.createElement(Component67),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/_layout",
    "element": React.createElement(Component68),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/_layout",
    "element": React.createElement(Component69),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/_settings",
    "element": React.createElement(Component70),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/_settings",
    "element": React.createElement(Component71),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "webpart/widgets/rss/default",
    "element": React.createElement(Component72),
    "caseSensitive": false,
    "meta": {
      "layout": "webpart"
    }
  },
  {
    "path": "embed/widgets/rss/default",
    "element": React.createElement(Component73),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "CardCreator",
    "element": React.createElement(Component74),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/CardCreator",
    "element": React.createElement(Component75),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/CardCreator",
    "element": React.createElement(Component76),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/CardCreator",
    "element": React.createElement(Component77),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "CardCreator102",
    "element": React.createElement(Component78),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/CardCreator102",
    "element": React.createElement(Component79),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/CardCreator102",
    "element": React.createElement(Component80),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/CardCreator102",
    "element": React.createElement(Component81),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "CardForm",
    "element": React.createElement(Component82),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/CardForm",
    "element": React.createElement(Component83),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/CardForm",
    "element": React.createElement(Component84),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/CardForm",
    "element": React.createElement(Component85),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "CardGrid",
    "element": React.createElement(Component86),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/CardGrid",
    "element": React.createElement(Component87),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/CardGrid",
    "element": React.createElement(Component88),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/CardGrid",
    "element": React.createElement(Component89),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "JsonDateConverter",
    "element": React.createElement(Component90),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/JsonDateConverter",
    "element": React.createElement(Component91),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/JsonDateConverter",
    "element": React.createElement(Component92),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/JsonDateConverter",
    "element": React.createElement(Component93),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "RSSForm",
    "element": React.createElement(Component94),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/RSSForm",
    "element": React.createElement(Component95),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/RSSForm",
    "element": React.createElement(Component96),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/RSSForm",
    "element": React.createElement(Component97),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "RecentContactList",
    "element": React.createElement(Component98),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/RecentContactList",
    "element": React.createElement(Component99),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/RecentContactList",
    "element": React.createElement(Component100),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/RecentContactList",
    "element": React.createElement(Component101),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "RestForm",
    "element": React.createElement(Component102),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/RestForm",
    "element": React.createElement(Component103),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/RestForm",
    "element": React.createElement(Component104),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/RestForm",
    "element": React.createElement(Component105),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "RestForm2",
    "element": React.createElement(Component106),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/RestForm2",
    "element": React.createElement(Component107),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/RestForm2",
    "element": React.createElement(Component108),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/RestForm2",
    "element": React.createElement(Component109),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "RestForm3",
    "element": React.createElement(Component110),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/RestForm3",
    "element": React.createElement(Component111),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/RestForm3",
    "element": React.createElement(Component112),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/RestForm3",
    "element": React.createElement(Component113),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "UserInfoCard",
    "element": React.createElement(Component114),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/UserInfoCard",
    "element": React.createElement(Component115),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/UserInfoCard",
    "element": React.createElement(Component116),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/UserInfoCard",
    "element": React.createElement(Component117),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "WidgetConfig",
    "element": React.createElement(Component118),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/WidgetConfig",
    "element": React.createElement(Component119),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/WidgetConfig",
    "element": React.createElement(Component120),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/WidgetConfig",
    "element": React.createElement(Component121),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "apiSample",
    "element": React.createElement(Component122),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/apiSample",
    "element": React.createElement(Component123),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/apiSample",
    "element": React.createElement(Component124),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/apiSample",
    "element": React.createElement(Component125),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "arti",
    "element": React.createElement(Component126),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/arti",
    "element": React.createElement(Component127),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/arti",
    "element": React.createElement(Component128),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/arti",
    "element": React.createElement(Component129),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "artifact",
    "element": React.createElement(Component130),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/artifact",
    "element": React.createElement(Component131),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/artifact",
    "element": React.createElement(Component132),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/artifact",
    "element": React.createElement(Component133),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "asana-getTasksForProjectBoard",
    "element": React.createElement(Component134),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/asana-getTasksForProjectBoard",
    "element": React.createElement(Component135),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/asana-getTasksForProjectBoard",
    "element": React.createElement(Component136),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/asana-getTasksForProjectBoard",
    "element": React.createElement(Component137),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "auth-callback",
    "element": React.createElement(Component138),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/auth-callback",
    "element": React.createElement(Component139),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/auth-callback",
    "element": React.createElement(Component140),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/auth-callback",
    "element": React.createElement(Component141),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "auth-complete",
    "element": React.createElement(Component142),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/auth-complete",
    "element": React.createElement(Component143),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/auth-complete",
    "element": React.createElement(Component144),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/auth-complete",
    "element": React.createElement(Component145),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "calendar",
    "element": React.createElement(Component146),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/calendar",
    "element": React.createElement(Component147),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/calendar",
    "element": React.createElement(Component148),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/calendar",
    "element": React.createElement(Component149),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "card-embed",
    "element": React.createElement(Component150),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/card-embed",
    "element": React.createElement(Component151),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/card-embed",
    "element": React.createElement(Component152),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/card-embed",
    "element": React.createElement(Component153),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "chatsimple",
    "element": React.createElement(Component154),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/chatsimple",
    "element": React.createElement(Component155),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/chatsimple",
    "element": React.createElement(Component156),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/chatsimple",
    "element": React.createElement(Component157),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "clickup-GetFolder",
    "element": React.createElement(Component158),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/clickup-GetFolder",
    "element": React.createElement(Component159),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/clickup-GetFolder",
    "element": React.createElement(Component160),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/clickup-GetFolder",
    "element": React.createElement(Component161),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "clickup-Tasks",
    "element": React.createElement(Component162),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/clickup-Tasks",
    "element": React.createElement(Component163),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/clickup-Tasks",
    "element": React.createElement(Component164),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/clickup-Tasks",
    "element": React.createElement(Component165),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "configpage-proto1",
    "element": React.createElement(Component166),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/configpage-proto1",
    "element": React.createElement(Component167),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/configpage-proto1",
    "element": React.createElement(Component168),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/configpage-proto1",
    "element": React.createElement(Component169),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "confluence-getPageById",
    "element": React.createElement(Component170),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/confluence-getPageById",
    "element": React.createElement(Component171),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/confluence-getPageById",
    "element": React.createElement(Component172),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/confluence-getPageById",
    "element": React.createElement(Component173),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "confluence-getPages",
    "element": React.createElement(Component174),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/confluence-getPages",
    "element": React.createElement(Component175),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/confluence-getPages",
    "element": React.createElement(Component176),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/confluence-getPages",
    "element": React.createElement(Component177),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "counter",
    "element": React.createElement(Component178),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/counter",
    "element": React.createElement(Component179),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/counter",
    "element": React.createElement(Component180),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/counter",
    "element": React.createElement(Component181),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "dashboard",
    "element": React.createElement(Component182),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/dashboard",
    "element": React.createElement(Component183),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/dashboard",
    "element": React.createElement(Component184),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/dashboard",
    "element": React.createElement(Component185),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "datagrid",
    "element": React.createElement(Component186),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/datagrid",
    "element": React.createElement(Component187),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/datagrid",
    "element": React.createElement(Component188),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/datagrid",
    "element": React.createElement(Component189),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "default",
    "element": React.createElement(Component190),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/default",
    "element": React.createElement(Component191),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/default",
    "element": React.createElement(Component192),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/default",
    "element": React.createElement(Component193),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "dropbox-SearchAlert",
    "element": React.createElement(Component194),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/dropbox-SearchAlert",
    "element": React.createElement(Component195),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/dropbox-SearchAlert",
    "element": React.createElement(Component196),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/dropbox-SearchAlert",
    "element": React.createElement(Component197),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "edit",
    "element": React.createElement(Component198),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/edit",
    "element": React.createElement(Component199),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/edit",
    "element": React.createElement(Component200),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/edit",
    "element": React.createElement(Component201),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "formtest",
    "element": React.createElement(Component202),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/formtest",
    "element": React.createElement(Component203),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/formtest",
    "element": React.createElement(Component204),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/formtest",
    "element": React.createElement(Component205),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "formtest1",
    "element": React.createElement(Component206),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/formtest1",
    "element": React.createElement(Component207),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/formtest1",
    "element": React.createElement(Component208),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/formtest1",
    "element": React.createElement(Component209),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "gallery",
    "element": React.createElement(Component210),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/gallery",
    "element": React.createElement(Component211),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/gallery",
    "element": React.createElement(Component212),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/gallery",
    "element": React.createElement(Component213),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "genie-error1",
    "element": React.createElement(Component214),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/genie-error1",
    "element": React.createElement(Component215),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/genie-error1",
    "element": React.createElement(Component216),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/genie-error1",
    "element": React.createElement(Component217),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "genie",
    "element": React.createElement(Component218),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/genie",
    "element": React.createElement(Component219),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/genie",
    "element": React.createElement(Component220),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/genie",
    "element": React.createElement(Component221),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "hello",
    "element": React.createElement(Component222),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/hello",
    "element": React.createElement(Component223),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/hello",
    "element": React.createElement(Component224),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/hello",
    "element": React.createElement(Component225),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "hello0",
    "element": React.createElement(Component226),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/hello0",
    "element": React.createElement(Component227),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/hello0",
    "element": React.createElement(Component228),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/hello0",
    "element": React.createElement(Component229),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "hello1",
    "element": React.createElement(Component230),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/hello1",
    "element": React.createElement(Component231),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/hello1",
    "element": React.createElement(Component232),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/hello1",
    "element": React.createElement(Component233),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "hsl-color-converter",
    "element": React.createElement(Component234),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/hsl-color-converter",
    "element": React.createElement(Component235),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/hsl-color-converter",
    "element": React.createElement(Component236),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/hsl-color-converter",
    "element": React.createElement(Component237),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "hubspot-GetRecentContactList",
    "element": React.createElement(Component238),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/hubspot-GetRecentContactList",
    "element": React.createElement(Component239),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/hubspot-GetRecentContactList",
    "element": React.createElement(Component240),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/hubspot-GetRecentContactList",
    "element": React.createElement(Component241),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "jira-open-issues",
    "element": React.createElement(Component242),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/jira-open-issues",
    "element": React.createElement(Component243),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/jira-open-issues",
    "element": React.createElement(Component244),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/jira-open-issues",
    "element": React.createElement(Component245),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "linkedin-Carousel",
    "element": React.createElement(Component246),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/linkedin-Carousel",
    "element": React.createElement(Component247),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/linkedin-Carousel",
    "element": React.createElement(Component248),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/linkedin-Carousel",
    "element": React.createElement(Component249),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "linkedin-GetNewsFeed",
    "element": React.createElement(Component250),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/linkedin-GetNewsFeed",
    "element": React.createElement(Component251),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/linkedin-GetNewsFeed",
    "element": React.createElement(Component252),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/linkedin-GetNewsFeed",
    "element": React.createElement(Component253),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "linkedin-Grid",
    "element": React.createElement(Component254),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/linkedin-Grid",
    "element": React.createElement(Component255),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/linkedin-Grid",
    "element": React.createElement(Component256),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/linkedin-Grid",
    "element": React.createElement(Component257),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "linkedin-HeroWidget",
    "element": React.createElement(Component258),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/linkedin-HeroWidget",
    "element": React.createElement(Component259),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/linkedin-HeroWidget",
    "element": React.createElement(Component260),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/linkedin-HeroWidget",
    "element": React.createElement(Component261),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "linkedin-Slider",
    "element": React.createElement(Component262),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/linkedin-Slider",
    "element": React.createElement(Component263),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/linkedin-Slider",
    "element": React.createElement(Component264),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/linkedin-Slider",
    "element": React.createElement(Component265),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "llm-web-part-edit-recommendation",
    "element": React.createElement(Component266),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/llm-web-part-edit-recommendation",
    "element": React.createElement(Component267),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/llm-web-part-edit-recommendation",
    "element": React.createElement(Component268),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/llm-web-part-edit-recommendation",
    "element": React.createElement(Component269),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "llm-web-part-empty-state",
    "element": React.createElement(Component270),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/llm-web-part-empty-state",
    "element": React.createElement(Component271),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/llm-web-part-empty-state",
    "element": React.createElement(Component272),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/llm-web-part-empty-state",
    "element": React.createElement(Component273),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "maker0",
    "element": React.createElement(Component274),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/maker0",
    "element": React.createElement(Component275),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/maker0",
    "element": React.createElement(Component276),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/maker0",
    "element": React.createElement(Component277),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "microsoft-lists-TravelRequests",
    "element": React.createElement(Component278),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/microsoft-lists-TravelRequests",
    "element": React.createElement(Component279),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/microsoft-lists-TravelRequests",
    "element": React.createElement(Component280),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/microsoft-lists-TravelRequests",
    "element": React.createElement(Component281),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "msshifts-UpcomingShifts",
    "element": React.createElement(Component282),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/msshifts-UpcomingShifts",
    "element": React.createElement(Component283),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/msshifts-UpcomingShifts",
    "element": React.createElement(Component284),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/msshifts-UpcomingShifts",
    "element": React.createElement(Component285),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "news0",
    "element": React.createElement(Component286),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/news0",
    "element": React.createElement(Component287),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/news0",
    "element": React.createElement(Component288),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/news0",
    "element": React.createElement(Component289),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "news1",
    "element": React.createElement(Component290),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/news1",
    "element": React.createElement(Component291),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/news1",
    "element": React.createElement(Component292),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/news1",
    "element": React.createElement(Component293),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "outlook-MyInboxQuery",
    "element": React.createElement(Component294),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/outlook-MyInboxQuery",
    "element": React.createElement(Component295),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/outlook-MyInboxQuery",
    "element": React.createElement(Component296),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/outlook-MyInboxQuery",
    "element": React.createElement(Component297),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "outlook-SharedInboxQuery",
    "element": React.createElement(Component298),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/outlook-SharedInboxQuery",
    "element": React.createElement(Component299),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/outlook-SharedInboxQuery",
    "element": React.createElement(Component300),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/outlook-SharedInboxQuery",
    "element": React.createElement(Component301),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "outlook-calendar-wip",
    "element": React.createElement(Component302),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/outlook-calendar-wip",
    "element": React.createElement(Component303),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/outlook-calendar-wip",
    "element": React.createElement(Component304),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/outlook-calendar-wip",
    "element": React.createElement(Component305),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "outlook-calendar",
    "element": React.createElement(Component306),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/outlook-calendar",
    "element": React.createElement(Component307),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/outlook-calendar",
    "element": React.createElement(Component308),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/outlook-calendar",
    "element": React.createElement(Component309),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "outlook-focused-inbox",
    "element": React.createElement(Component310),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/outlook-focused-inbox",
    "element": React.createElement(Component311),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/outlook-focused-inbox",
    "element": React.createElement(Component312),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/outlook-focused-inbox",
    "element": React.createElement(Component313),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "outlook-upcoming-events",
    "element": React.createElement(Component314),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/outlook-upcoming-events",
    "element": React.createElement(Component315),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/outlook-upcoming-events",
    "element": React.createElement(Component316),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/outlook-upcoming-events",
    "element": React.createElement(Component317),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "pgquery",
    "element": React.createElement(Component318),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/pgquery",
    "element": React.createElement(Component319),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/pgquery",
    "element": React.createElement(Component320),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/pgquery",
    "element": React.createElement(Component321),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "podcast-list",
    "element": React.createElement(Component322),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/podcast-list",
    "element": React.createElement(Component323),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/podcast-list",
    "element": React.createElement(Component324),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/podcast-list",
    "element": React.createElement(Component325),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "podcasts-default",
    "element": React.createElement(Component326),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/podcasts-default",
    "element": React.createElement(Component327),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/podcasts-default",
    "element": React.createElement(Component328),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/podcasts-default",
    "element": React.createElement(Component329),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rhf-form1",
    "element": React.createElement(Component330),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rhf-form1",
    "element": React.createElement(Component331),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rhf-form1",
    "element": React.createElement(Component332),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rhf-form1",
    "element": React.createElement(Component333),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-BottomBar",
    "element": React.createElement(Component334),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-BottomBar",
    "element": React.createElement(Component335),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-BottomBar",
    "element": React.createElement(Component336),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-BottomBar",
    "element": React.createElement(Component337),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-CriticalAnnouncement",
    "element": React.createElement(Component338),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-CriticalAnnouncement",
    "element": React.createElement(Component339),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-CriticalAnnouncement",
    "element": React.createElement(Component340),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-CriticalAnnouncement",
    "element": React.createElement(Component341),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-HeroWidget",
    "element": React.createElement(Component342),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-HeroWidget",
    "element": React.createElement(Component343),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-HeroWidget",
    "element": React.createElement(Component344),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-HeroWidget",
    "element": React.createElement(Component345),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-ImportantNews",
    "element": React.createElement(Component346),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-ImportantNews",
    "element": React.createElement(Component347),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-ImportantNews",
    "element": React.createElement(Component348),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-ImportantNews",
    "element": React.createElement(Component349),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-NewsCarousel",
    "element": React.createElement(Component350),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-NewsCarousel",
    "element": React.createElement(Component351),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-NewsCarousel",
    "element": React.createElement(Component352),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-NewsCarousel",
    "element": React.createElement(Component353),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-NewsCarouselLargeImage (1)",
    "element": React.createElement(Component354),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-NewsCarouselLargeImage (1)",
    "element": React.createElement(Component355),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-NewsCarouselLargeImage (1)",
    "element": React.createElement(Component356),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-NewsCarouselLargeImage (1)",
    "element": React.createElement(Component357),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-NewsCarouselLargeImage",
    "element": React.createElement(Component358),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-NewsCarouselLargeImage",
    "element": React.createElement(Component359),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-NewsCarouselLargeImage",
    "element": React.createElement(Component360),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-NewsCarouselLargeImage",
    "element": React.createElement(Component361),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-NewsGallery",
    "element": React.createElement(Component362),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-NewsGallery",
    "element": React.createElement(Component363),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-NewsGallery",
    "element": React.createElement(Component364),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-NewsGallery",
    "element": React.createElement(Component365),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-NewsReader",
    "element": React.createElement(Component366),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-NewsReader",
    "element": React.createElement(Component367),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-NewsReader",
    "element": React.createElement(Component368),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-NewsReader",
    "element": React.createElement(Component369),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-Ticker",
    "element": React.createElement(Component370),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-Ticker",
    "element": React.createElement(Component371),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-Ticker",
    "element": React.createElement(Component372),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-Ticker",
    "element": React.createElement(Component373),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-TopBar",
    "element": React.createElement(Component374),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-TopBar",
    "element": React.createElement(Component375),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-TopBar",
    "element": React.createElement(Component376),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-TopBar",
    "element": React.createElement(Component377),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-conconf",
    "element": React.createElement(Component378),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-conconf",
    "element": React.createElement(Component379),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-conconf",
    "element": React.createElement(Component380),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-conconf",
    "element": React.createElement(Component381),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "rss-default",
    "element": React.createElement(Component382),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/rss-default",
    "element": React.createElement(Component383),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/rss-default",
    "element": React.createElement(Component384),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/rss-default",
    "element": React.createElement(Component385),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "settings",
    "element": React.createElement(Component386),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/settings",
    "element": React.createElement(Component387),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/settings",
    "element": React.createElement(Component388),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/settings",
    "element": React.createElement(Component389),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "slack-ConversationHistory-compact",
    "element": React.createElement(Component390),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/slack-ConversationHistory-compact",
    "element": React.createElement(Component391),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/slack-ConversationHistory-compact",
    "element": React.createElement(Component392),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/slack-ConversationHistory-compact",
    "element": React.createElement(Component393),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "slack-ConversationHistory-v0",
    "element": React.createElement(Component394),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/slack-ConversationHistory-v0",
    "element": React.createElement(Component395),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/slack-ConversationHistory-v0",
    "element": React.createElement(Component396),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/slack-ConversationHistory-v0",
    "element": React.createElement(Component397),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "slack-ConversationHistory",
    "element": React.createElement(Component398),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/slack-ConversationHistory",
    "element": React.createElement(Component399),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/slack-ConversationHistory",
    "element": React.createElement(Component400),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/slack-ConversationHistory",
    "element": React.createElement(Component401),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "stock-quote-Widget",
    "element": React.createElement(Component402),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/stock-quote-Widget",
    "element": React.createElement(Component403),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/stock-quote-Widget",
    "element": React.createElement(Component404),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/stock-quote-Widget",
    "element": React.createElement(Component405),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "typography",
    "element": React.createElement(Component406),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/typography",
    "element": React.createElement(Component407),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/typography",
    "element": React.createElement(Component408),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/typography",
    "element": React.createElement(Component409),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "xero-employee-leave-uk-nz",
    "element": React.createElement(Component410),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/xero-employee-leave-uk-nz",
    "element": React.createElement(Component411),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/xero-employee-leave-uk-nz",
    "element": React.createElement(Component412),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/xero-employee-leave-uk-nz",
    "element": React.createElement(Component413),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  },
  {
    "path": "xkcd",
    "element": React.createElement(Component414),
    "caseSensitive": false,
    "meta": {
      "layout": "app"
    }
  },
  {
    "path": "admin/xkcd",
    "element": React.createElement(Component415),
    "caseSensitive": false,
    "meta": {
      "layout": "admin"
    }
  },
  {
    "path": "embed/xkcd",
    "element": React.createElement(Component416),
    "caseSensitive": false,
    "meta": {
      "layout": "embed"
    }
  },
  {
    "path": "gadget/xkcd",
    "element": React.createElement(Component417),
    "caseSensitive": false,
    "meta": {
      "layout": "gadget"
    }
  }
];

export default routes;